// extracted by mini-css-extract-plugin
module.exports = {"button":"_2QWkR_SqRuzTE0kGlBv2YF"};